import React, { useEffect, useMemo, useState } from "react";
import logoQatar from "../../images/logoQatar.jpg";
import { useSelector, useDispatch } from "react-redux";
import { updateFiguritas } from "../../actions/figuritasActions";
import SelectComponent from "../Select/SelectComponent";
import { getAlbumById } from "../../firebase/firestore";
import UserProfileDropdown from "./UserProfileDropdown";

export default function Navbar() {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser.user);
  const albums = useSelector((state) => state.figuritasReducer);

  const { innerWidth } = window;

  const options = useMemo(() => {
    if (albums.miAlbum) return getOptions();
    return [];
  }, [albums]);

  function getOptions() {
    let options = [];
    options.push({
      label: `Tu Álbum (${albums.miAlbum.owner.name})`,
      value: albums.miAlbum.albumID,
    });
    albums.albumsAutorizados.forEach((album) =>
      options.push({
        label: album.album.owner.name,
        value: album.album.albumID,
      })
    );
    return options;
  }
  function getAlbumFromId(id) {
    getAlbumById(id).then((result) => {
      if (result) {
        dispatch(updateFiguritas(result));
      } else {
        dispatch(updateFiguritas(albums.miAlbum));
      }
    });
  }

  return (
    <nav>
      {innerWidth > 1200 ? (
        <>
          <img src={logoQatar} alt="Logo Qatar 2022" width="200" />
          <div className="seleccionarAlbum">
            {albums.miAlbum !== null ? (
              <>
                <p>Elegir álbum</p>
                <SelectComponent
                  options={options}
                  placeholder="Tu Álbum"
                  onChange={(value) => {
                    getAlbumFromId(value?.value);
                  }}
                />
              </>
            ) : (
              currentUser && (
                <>
                  <p>Elegir álbum</p>
                  <SelectComponent
                    options={[]}
                    placeholder="Cargando..."
                    onChange={() => {}}
                    loading
                  />
                </>
              )
            )}
          </div>
          <div className="navProfileWrapper">
            {currentUser ? (
              <>
                <img
                  src={currentUser.photoURL}
                  alt={currentUser.displayName}
                  onClick={() => {
                    showUserMenu
                      ? setShowUserMenu(false)
                      : setShowUserMenu(true);
                  }}
                  id={showUserMenu ? "menuActive" : ""}
                />
                {showUserMenu && (
                  <UserProfileDropdown currentUser={currentUser} />
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        <>
          <div className="navMobileWrapper">
            <img src={logoQatar} alt="Logo Qatar 2022" width="200" />
            <div className="navProfileWrapper">
              {currentUser ? (
                <>
                  <img
                    src={currentUser.photoURL}
                    alt={currentUser.displayName}
                    onClick={() => {
                      showUserMenu
                        ? setShowUserMenu(false)
                        : setShowUserMenu(true);
                    }}
                    id={showUserMenu ? "menuActive" : ""}
                  />
                  {showUserMenu && (
                    <UserProfileDropdown currentUser={currentUser} />
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="seleccionarAlbum">
            {albums.miAlbum ? (
              <>
                <p>Elegir álbum</p>
                <SelectComponent
                  options={options}
                  placeholder="Álbum"
                  onChange={(value) => {
                    getAlbumFromId(value?.value);
                  }}
                  defaultValues={{
                    label: `Tu Álbum (${albums.miAlbum.owner.name})`,
                    value: albums.miAlbum.albumID,
                  }}
                />
              </>
            ) : (
              currentUser && (
                <>
                  <p>Elegir álbum</p>
                  <SelectComponent
                    options={[]}
                    placeholder="Cargando..."
                    onChange={() => {}}
                    loading
                  />
                </>
              )
            )}
          </div>
        </>
      )}
    </nav>
  );
}
